import { defineStore } from 'pinia'
import apiService from '@/utils/services/apiService'
import API from '@/utils/constants/apiUrls'

interface SystemStatusData {
  systemStatus: string
  displayStatus: string
  title: string
  description: string
}

export const useSystemStatusStore = defineStore('systemStatus', {
  state: () => ({
    announcementData: null as SystemStatusData | null,
    isLoading: false,
    error: null as string | null
  }),
  getters: {
    isAnnouncementVisible: (state) => {
      return (
        state.announcementData?.systemStatus === 'operational' &&
        state.announcementData?.displayStatus === 'visible'
      )
    }
  },
  actions: {
    async getSystemStatus() {
      if (this.isLoading) return

      this.isLoading = true
      this.error = null

      try {
        const response = await apiService.get(
          API.CMS.SYSTEM_STATUS.GET_SYSTEM_STATUS
        )
        this.announcementData = response.data.data
      } catch (err) {
        console.error('Failed to fetch system status:', err)
        this.error = 'Failed to fetch system status'
      } finally {
        this.isLoading = false
      }
    },
    clearAnnouncement() {
      this.announcementData = null
    }
  }
})
